import { Suspense } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet } from 'react-router-dom';

import { GlobalErrorFallback } from './components/ErrorFallback/GlobalErrorFallback';
import Loading from './components/loading';
import { getAccessToken } from './http';
import iframeAuthService from './services/iframeAuth';

const PrivateRoute = (): JSX.Element => {
  // Check if authenticated
  if (getAccessToken()) {
    return (
      <ErrorBoundary key="global" FallbackComponent={GlobalErrorFallback}>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    );
  }

  // Check if iframe auth is in progress
  if (iframeAuthService.isInIframe() && iframeAuthService.isLoading()) {
    return <Loading />;
  }

  // Not authenticated and not loading - redirect to login
  return <Navigate to="/login" />;
};

export default PrivateRoute;
